import React, { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useSearchParams } from "react-router-dom";

const StockFilter = (props) => {
  //   const [values, setValues] = React.useState([]);
  const [value, setValue] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  let [searchParams, setSearchParams] = useSearchParams();

  const handleChange = (event) => {
    if (event.target.value === "None") {
      setValue("");
    } else {
      setValue(event.target.value);
    }
  };

  useEffect(() => {
    setLoading(true);
    if (searchParams.get(props.label)) {
      const value = searchParams.get(props.label);
      setValue(value);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!loading) {
      if (value.length > 0) {
        let params = new URLSearchParams(searchParams);
        if (params.get(props.label)) {
          if (params.get(props.label) !== value) {
            params.delete(props.label);
            params.append(props.label, value);
            setSearchParams(params);
          }
        } else {
          params.append(props.label, value);
          setSearchParams(params);
        }
      } else {
        let params = new URLSearchParams(searchParams);
        if (params.get(props.label)) {
          params.delete(props.label);
          setSearchParams(params);
        }
      }
    }
  }, [value, searchParams, setSearchParams]);

  //   const handleChange = (event) => {
  //     const {
  //       target: { value },
  //     } = event;
  //     setValues(
  //       // On autofill we get a stringified value.
  //       typeof value === "string" ? value.split(",") : value
  //     );
  //   };

  //   useEffect(() => {
  //     setLoading(true);
  //     if (searchParams.get(props.label)) {
  //       const values = searchParams.get(props.label).split(",");
  //       setValues(values);
  //     }
  //     setLoading(false);
  //   }, []);

  //   useEffect(() => {
  //     // const searchParams = new URLSearchParams(location.search);
  //     // searchParams.set(props.label, values.join(","));
  //     if (!loading) {
  //       if (values.length > 0) {
  //         let params = new URLSearchParams(searchParams);
  //         console.log(params.toString());
  //         if (params.get(props.label)) {
  //           if (params.get(props.label) !== values.join(",")) {
  //             params.delete(props.label);
  //             params.append(props.label, values.join(","));
  //             setSearchParams(params);
  //           }
  //         } else {
  //           params.append(props.label, values.join(","));
  //           setSearchParams(params);
  //         }
  //       } else {
  //         let params = new URLSearchParams(searchParams);
  //         if (params.get(props.label)) {
  //           params.delete(props.label);
  //           setSearchParams(params);
  //         }
  //       }
  //     }
  //   }, [values, searchParams, setSearchParams]);

  return (
    <FormControl fullWidth style={{ maxWidth: "300px" }} size="small">
      <InputLabel id="demo-simple-select-label">{props.name}</InputLabel>
      {/* <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={values}
        multiple
        label={props.name}
        onChange={handleChange}
      >
        {props.data.map((item) => {
          return <MenuItem value={item}>{item}</MenuItem>;
        })}
      </Select> */}
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={value}
        label={props.name}
        onChange={handleChange}
      >
        <MenuItem value="None">None</MenuItem>
        {props.data.map((item, index) => {
          return (
            <MenuItem key={index} value={item}>
              {item}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default StockFilter;
